<div class="sec-container">
  <h2>Ответы на популярные вопросы</h2>

  <div class="accordion" id="accordionExample2">
    <div class="accordion-item">
      <h5 class="accordion-header" id="heading1">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapse1"
          aria-expanded="true"
          aria-controls="collapse1"
        >
          <h5>Как происходит оплата за услуги?</h5>
        </button>
      </h5>
      <div
        id="collapse1"
        class="accordion-collapse collapse"
        aria-labelledby="heading1"
        data-bs-parent="#accordionExample2"
      >
        <div class="accordion-body">
          Оплата за услуги производится после заполнения анкеты на нашем сайте.
          Вы сможете выбрать удобный способ оплаты через безопасную банковскую
          платежную систему. Мы принимаем различные карты и электронные платежи
          для вашего удобства. После завершения оплаты ваша заявка будет
          обработана, и мы приступим к выполнению заказа. Если у вас возникнут
          вопросы по оплате, наша служба поддержки всегда готова помочь!
        </div>
      </div>
    </div>

    <div class="accordion-item">
      <h5 class="accordion-header" id="heading2">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapse2"
          aria-expanded="false"
          aria-controls="collapse2"
        >
          <h5>Когда со мной свяжется менеджер?</h5>
        </button>
      </h5>
      <div
        id="collapse2"
        class="accordion-collapse collapse"
        aria-labelledby="heading2"
        data-bs-parent="#accordionExample2"
      >
        <div class="accordion-body">
          Наш менеджер свяжется с вами в кратчайшие сроки после заполнения
          анкеты на сайте. Обычно это происходит в течение 1–2 часов в рабочее
          время. Если вы оставили заявку вечером или ночью, мы перезвоним вам на
          следующий день утром. Для ускорения обработки заявки убедитесь, что в
          анкете указаны актуальный телефон и email.
        </div>
      </div>
    </div>

    <div class="accordion-item">
      <h5 class="accordion-header" id="heading3">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapse3"
          aria-expanded="false"
          aria-controls="collapse3"
        >
          <h5>Можно ли отредактировать страницу после публикации?</h5>
        </button>
      </h5>
      <div
        id="collapse3"
        class="accordion-collapse collapse"
        aria-labelledby="heading3"
        data-bs-parent="#accordionExample2"
      >
        <div class="accordion-body">
          Да, после публикации страницы памяти, у вас есть возможность один раз
          внести правки. Для этого свяжитесь с нашим менеджером — он поможет
          откорректировать текст, фотографию или другие детали.
        </div>
      </div>
    </div>

    <div class="accordion-item">
      <h5 class="accordion-header" id="heading4">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapse4"
          aria-expanded="false"
          aria-controls="collapse4"
        >
          <h5>Что делать, если QR-код не работает?</h5>
        </button>
      </h5>
      <div
        id="collapse4"
        class="accordion-collapse collapse"
        aria-labelledby="heading4"
        data-bs-parent="#accordionExample2"
      >
        <div class="accordion-body">
          Если QR-код на памятной странице не срабатывает, пожалуйста, выполните
          следующие шаги:
          <ol>
            <li>
              Проверьте качество сканирования – убедитесь, что камера хорошо
              фокусируется на коде, а изображение не повреждено и не засвечено.
            </li>
            <li>
              Обновите страницу или перезагрузите ее, чтобы исключить временные
              сбои.
            </li>
            <li>
              Если проблема не решена, свяжитесь с нами через удобный способ
              связи указанный в контактной информациим – мы оперативно проверим
              код и при необходимости заменим его.
            </li>
          </ol>
        </div>
      </div>
    </div>

    <div class="accordion-item">
      <h5 class="accordion-header" id="heading5">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapse5"
          aria-expanded="false"
          aria-controls="collapse5"
        >
          <h5>Насколько безопасны мои данные?</h5>
        </button>
      </h5>
      <div
        id="collapse5"
        class="accordion-collapse collapse"
        aria-labelledby="heading5"
        data-bs-parent="#accordionExample2"
      >
        <div class="accordion-body">
          Безопасность ваших персональных данных — наш приоритет. Мы гарантируем
          их защиту следующим образом
          <ol>
            <li>
              Шифрование информации – все данные передаются и хранятся в
              зашифрованном виде с использованием современных протоколов
              безопасности.
            </li>
            <li>
              Ограниченный доступ – только уполномоченные сотрудники имеют
              доступ к вашей информации, и строго в рамках выполнения заказа.
            </li>
            <li>
              Соблюдение закона – мы работаем в соответствии с законодательством
              РБ о защите персональных данных (Закон №99-З от 07.05.2021).
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</div>
